<template>
  <div>
    <el-dialog :visible.sync="dialogShow" :width="`${width}px`" :close-on-click-modal="false" @close="closeDialog"
      append-to-body class="tipConfirmDialogContent dialogBoxFormat" destroy-on-close>
      <div slot="title">
        操作日志
      </div>
      <slot></slot>
      <div class="center">
        <MyTable :table-data="tableData"
                 :isLoading="listLoading"
                 :index="index"
                 :selection="selection"
                 :page="page"
                 :operation="operation"
                 :table-option.sync="tableOption"
                 @page-change="getList"
                 @handleSelectionChange="currentChange"> 
        </MyTable>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import MyTable from '@/components/myTable'
import { querySysWriteLogList } from '@/api/systemRole'

export default {
  name: "ConfirmDialog",
  components: {MyTable},
  props: { 
    confirmLabel: {
      default: "确定",
    },
    width: {
      default: 800,
    },
    btnLoading: {
      default: false,
    },
    showFooter: {
      default: true,
    },
  },
  data() {
    return {
      dialogShow:false,
      listLoading:false,
      operation: false,
      selection: false,
      index: true,
      tableData: [],
      tableOption: [
        { label: '操作人', prop: 'operName' }, 
        { label: 'IP地址', prop: 'operIp' },
        { label: '变更内容', prop: 'postEdit',width:'300px' },
        { label: '变更时间', prop: 'createTime',width:'160px' }
      ],
      page: { total: 10, current: 1, size: 10 },
      pageType:null,
    };
  },
  computed: {},
  methods: {
    closeDialog() {
      // this.$emit("updateDialogShow", false);
      this.dialogShow = false;
    },
    confirm() {
      this.$emit("confirm");
    },
    currentChange (val) {
      console.log('current', val)
    },
    init(type,id) {
     
      this.dialogShow = true;
      if(type =='userList'){
        this.pageType = 'userList';
      }
      if(type =='rolesList'){
        this.pageType = 'rolesList'; 
      }
      this.id= id;
      this.getList(type, this.id)

    },
    getList (type) { 
      const { current, size } = this.page
      let d = { current, size } 
     this.pageType =='userList'? d.businessType ='USER' : d.businessType ='ROLE';
     d.businessId = this.id;
      this.listLoading = true
      querySysWriteLogList(d).then((res) => {
        this.tableData = res.records;
        this.page.total = res.total
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
  },
  created() { },
  mounted() {

  },
  destroyed() { },
};
</script>
  
<style scoped lang="scss"></style>
  